import { motion } from "framer-motion";
import React from "react";
import { BodyText } from "../../styles/global";
import {
  WrapperMainOne,
  TitleText,
  LeftSection,
  RightSection,
} from "./Main.styles";

export const MainSectionOne = () => {
  return (
    <>
      <WrapperMainOne>
        <LeftSection>
          <div>
            <motion.div>
              <img src="img/lf20_gXacS6.json].jpg" alt="" />
            </motion.div>
          </div>
        </LeftSection>
        <RightSection>
          <TitleText>
            <div>Committed to your privacy and security</div>
            <BodyText>
              <p className="ensureText">
                We ensure your card details are secured by encryption and your
                informations with the highest level of internet security on our
                platform. All funds are securely warehoused by FSDH Merchant
                bank.
              </p>
            </BodyText>
          </TitleText>
        </RightSection>
      </WrapperMainOne>
    </>
  );
};
